import ProfitLossReportEditConfigController from './ProfitLossReportEditConfigController'

export default class ProfitLossReportEditResultConfigController extends ProfitLossReportEditConfigController {}

ProfitLossReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    return reportParameters
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ProfitLossReportEditResultConfigController.js